/**
 * Add a loading on the center of the element
 **/
(function (module) {
    module.directive('loader', ['$compile', function ($compile) {
        return {
            restrict: 'A',
            scope: {
                loader: '='
            },
            link: function (scope, element, attr) {
                var template = $compile('<md-progress-circular md-diameter="30" class="loader-progress"></md-progress-circular>')(scope);
                var activeClass = 'loader__active';
                element.css('position', 'relative');
                element.addClass('loader');
                element.append(template);

                var ev = scope.$watch('loader', function () {
                    if (scope.loader === true) {
                        element.addClass(activeClass);
                    } else {
                        element.removeClass(activeClass);
                    }
                });
                scope.$on('$destroy', function () {
                    ev();
                });
            }
        };
    }]);
}(angular.module('emarket.commons')));
